<template>
  <div class="chart-wrapper">
    <Bar :data="chartData" :options="options" />
  </div>
</template>

<script>
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'vue-chartjs'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    totalControles: { type: Number, default: 0 },
    controleImplementado: { type: Number, default: 0 },
    controleParcial: { type: Number, default: 0 },
    controleNaoImplementado: { type: Number, default: 0 },
    controleNaoAplicavel: { type: Number, default: 0 },
    nivelMaturidade: { type: Number, default: 0 },
  },
  computed: {
    chartData() {
      const {
        controleImplementado,
        controleNaoImplementado,
        controleParcial,
        controleNaoAplicavel,
      } = this
      return {
        labels: [
          'Implementado',
          'Não se aplica',
          'Parcial',
          'Não implementado',
        ],
        datasets: [
          {
            data: [
              controleImplementado,
              controleNaoAplicavel,
              controleParcial,
              controleNaoImplementado,
            ],
            backgroundColor: [
              'rgba(109, 219, 156)',
              'rgba(164, 174, 175)',
              'rgba(244, 213, 86)',
              'rgba(237, 129, 117)',
            ],
            borderColor: [
              'rgba(109, 219, 156)',
              'rgba(164, 174, 175)',
              'rgba(244, 213, 86)',
              'rgba(237, 129, 117)',
            ],
            borderWidth: 1,
          },
        ],
      }
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false, // necessário para usar altura do container
        plugins: { legend: { display: false }, datalabels: {} },
        layout: { padding: { top: 20, bottom: 60 } },
        scales: { y: { beginAtZero: true } },
      }
    },
  },
}
</script>

<style scoped>
.chart-wrapper {
  width: 100%;
  max-width: 700px;
  height: 400px;
  margin: 0 auto;
  padding: 10px;
}

@media (max-width: 768px) {
  .chart-wrapper {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .chart-wrapper {
    height: 250px;
  }
}
</style>
